var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "vue";
const REGEX = {
  NUMBERS_ONLY: /[^0-9]/g,
  ALLOWED_INPUT_CHARACTERS: /[^0-9\,]/g,
  FORMATTED_NUMBERS: /\B(?=([0-9]{3})+(?![0-9]))/g
};
class InputHandler {
  constructor(input, options = {}) {
    __publicField(this, "inputEl");
    __publicField(this, "state", {
      selectionStart: 0,
      selectionEnd: 0,
      value: ""
    });
    __publicField(this, "options", {
      align: "right",
      decimal: ".",
      precision: 2,
      thousands: ",",
      allowNull: true
    });
    this.inputEl = input;
    this.setOptions(options);
    this.bindEvents();
  }
  setOptions(options = {}) {
    this.options = { ...this.options, ...options };
  }
  setNumberValue(value) {
    this.updateInputValue(typeof value === "number" ? value.toString() : "", 0, false);
  }
  bindEvents() {
    this.inputEl.addEventListener("keydown", this.handleKeyDown.bind(this));
    this.inputEl.addEventListener("keypress", this.handleKeypress.bind(this));
    this.inputEl.addEventListener("paste", this.handlePaste.bind(this));
    this.inputEl.addEventListener("cut", this.handleCut.bind(this));
    this.inputEl.setNumberValue = this.setNumberValue.bind(this);
  }
  handleKeyDown(event) {
    this.updateInputState();
    const keyCode = event.which || event.charCode || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      event.preventDefault();
      this.removeChar(keyCode);
    }
  }
  handleKeypress(event) {
    const keyCode = event.which || event.charCode || event.keyCode;
    event.preventDefault();
    this.addChar(keyCode);
  }
  handlePaste(event) {
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    if (paste.match(REGEX.ALLOWED_INPUT_CHARACTERS)) {
      event.preventDefault();
      return;
    }
    this.updateInputState();
    let { selectionEnd, value } = this.state;
    setTimeout(() => {
      const newValue = this.inputEl.value;
      const selectionStart = selectionEnd + (newValue.length - value.length);
      this.updateInputValue(newValue, selectionStart);
    });
  }
  handleCut(event) {
    this.updateInputState();
    let { selectionStart } = this.state;
    setTimeout(() => {
      const newValue = this.inputEl.value;
      this.updateInputValue(newValue, selectionStart);
    });
  }
  addChar(keyCode) {
    const { selectionStart, selectionEnd, value } = this.state;
    const keyChar = String.fromCharCode(keyCode);
    if (!value) {
      this.updateInputValue(keyChar, keyChar.length);
    } else {
      const valueStart = value.substring(0, selectionStart);
      let valueEnd = value.substring(selectionEnd);
      const newValue = valueStart + keyChar + valueEnd;
      this.updateInputValue(newValue, selectionStart + 1);
    }
  }
  removeChar(charCode) {
    let { selectionStart, selectionEnd, value } = this.state;
    if (selectionStart === selectionEnd) {
      if (charCode === 8) {
        if (!value.charAt(selectionStart - 1).match(/\d/)) {
          selectionStart--;
          selectionEnd--;
        }
        selectionStart--;
      } else if (charCode === 46) {
        if (!value.charAt(selectionStart).match(/\d/)) {
          selectionStart++;
          selectionEnd++;
        }
        selectionEnd++;
      }
    }
    const newValue = value.substring(0, selectionStart) + value.substring(selectionEnd);
    this.updateInputValue(newValue, selectionStart);
  }
  updateInputValue(currentValue, selectionStart, triggerEvent = true) {
    const { thousands } = this.options;
    const { formattedValue, numberValue } = this.formatValue(currentValue, thousands);
    this.inputEl.value = formattedValue;
    if (triggerEvent) {
      selectionStart = selectionStart - (currentValue.length - formattedValue.length);
      this.setCursorAt(selectionStart);
      this.state.selectionStart = selectionStart;
      this.inputEl.dispatchEvent(new CustomEvent("number-change", {
        detail: {
          number: numberValue
        }
      }));
    }
  }
  updateInputState() {
    const { selectionStart, selectionEnd, value } = this.inputEl;
    this.state = {
      selectionStart: selectionStart || 0,
      selectionEnd: selectionEnd || 0,
      value
    };
  }
  setCursorAt(position) {
    this.inputEl.focus();
    this.inputEl.setSelectionRange(position, position);
  }
  formatValue(newValue, thousands) {
    const { allowNull } = this.options;
    if (newValue === "" && allowNull) {
      return { formattedValue: "", numberValue: null };
    }
    const numberValue = newValue.replace(REGEX.NUMBERS_ONLY, "");
    const formattedValue = numberValue.replace(REGEX.FORMATTED_NUMBERS, thousands);
    return { formattedValue, numberValue: +numberValue };
  }
}
const handlerMap = /* @__PURE__ */ new WeakMap();
const onCreated = (el, binding) => {
  const inputHandler = new InputHandler(el, binding.value);
  handlerMap.set(el, inputHandler);
};
const onMount = (el) => {
  const inputHandler = handlerMap.get(el);
  el.style.textAlign = inputHandler.options.align;
};
const onUpdated = (el, binding) => {
  const inputHandler = handlerMap.get(el);
  inputHandler.setOptions(binding.value);
};
const onUnmounted = (el) => {
  handlerMap.delete(el);
};
var NumericInput = {
  created: onCreated,
  mounted: onMount,
  updated: onUpdated,
  unmouned: onUnmounted
};
export { NumericInput as default };
